import { AxiosInstance } from 'axios';
import CacheService from './cacheService';

export default function useCache( axiosIns: AxiosInstance, cacheOverrideConfig: Object ) {
  const cache = new CacheService( axiosIns, cacheOverrideConfig )

  return {
    cache,
  }
}